var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../api/axios";
import * as yup from "yup";
import { DeliveryFormText } from "./Location-types";
export const postalCodeInputSchema = yup.object().shape({
    postalCode: yup.string().required(DeliveryFormText.REQUIRED_POSTAL_CODE),
});
/**
 * Validates postal code before going to Order Flow
 * @param sku
 * @param setLoading
 * @param setError
 * @param navigate
 * @returns
 */
export const postalCodeSubmit = (sku, setLoading, setError, navigate, programId) => (formData) => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    yield axiosPrivate
        .get(`/Location/ValidatePostalCode?sku=${sku}&postalCode=${formData.postalCode}&programId=${programId}`)
        .then(({ data }) => {
        var _a;
        if (data.success) {
            navigate(`/${sku}/OrderFlow`, { state: { postalCode: formData.postalCode } });
        }
        else {
            setLoading(false);
            setError("postalCode", { message: (_a = data.message) !== null && _a !== void 0 ? _a : DeliveryFormText.DO_NOT_DELIVER, type: "custom" });
        }
    })
        .catch((e) => console.error("Postal Code Submit ERROR", e));
});
/**
 * Brings the user to Order Flow after selecting a location
 * @param navigate
 * @param sku
 * @param location
 * @returns
 */
export const handleLocationClick = (navigate, sku, location) => (event) => {
    navigate(`/${sku}/OrderFlow`, { state: { location } });
};
/**
 * Sorts pickup locations by location sequence
 * @param a
 * @param b
 * @returns sorted pick up locations
 */
export const locationSorter = (a, b) => a.locationSeq.localeCompare(b.locationSeq, undefined, { numeric: true });
